/**
 * 基础菜单 班级管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>班级管理</el-breadcrumb-item>
    </el-breadcrumb>


    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="queryParams.className" placeholder="输入班级名称"></el-input>
      </el-form-item>
      <el-form-item label="" v-if="systemFlag == 1">
        <el-input size="small" v-model="queryParams.orgName" placeholder="输入客户名称"></el-input>
      </el-form-item>
      <el-form-item label="" v-if="systemFlag == 1">
        <el-cascader
          size="small"
          placeholder="选择考试科目"
          style="width: 100%"
          v-model="queryParams.subjectId"
          :options="treeOptions"
          emitPath="false"
          :props="{ emitPath:false }"
          clearable
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()" v-if="systemFlag != 1">添加</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" :data="listData" :key="color_index" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60">
      </el-table-column>
      <el-table-column prop="orgName" label="客户名称"/>
      <el-table-column prop="className" label="班级名称" width="250" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-link type="primary" @click="openStudent(scope.row)">
            <span v-html="changeColor(scope.row.className)"></span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="subjectName" label="培训科目" width="350" :show-overflow-tooltip="true"/>
      <el-table-column prop="studentNum" label="学生数"/>
      <el-table-column prop="activeNum" label="已激活人数"/>
      <el-table-column prop="createTime" label="创建时间"/>
      <el-table-column align="center" label="操作" width="200" v-if="systemFlag != 1">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <el-button
              size="mini"
              icon="el-icon-edit-outline"
              @click="handleEdit(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="deleteUser(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>

        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="30%" :close-on-click-modal="false" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-form-item label="培训科目" prop="subjectId">
          <el-cascader
            size="small"
            style="width: 100%"
            v-model="form.subjectId"
            :options="treeOptions"
            emitPath="false"
            :props="{ emitPath:false }"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="班级名称" prop="className">
          <el-input size="small" maxLength="255" v-model="form.className" placeholder="请输入班级名称"></el-input>
        </el-form-item>
        <el-form-item label="培训开始时间" prop="studyStartTime">
          <el-date-picker type="datetime" placeholder="选择培训开始时间" v-model="form.pxKssj" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="培训结束时间" prop="studyStopTime">
          <el-date-picker type="datetime" placeholder="选择培训结束时间" v-model="form.pxJssj" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="班主任" prop="bzr">
          <el-input size="small" maxLength="10" v-model="form.bzr" placeholder="请输入班主任"></el-input>
        </el-form-item>
        <el-form-item label="班主任电话" prop="bzrPhone">
          <el-input size="small" maxLength="11" v-model="form.bzrPhone" placeholder="请输入班主任电话"></el-input>
      </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { identificationRecognize, idCardIdentify } from '../../api/baidu'
import { identification, formatInportData, timestampToTime } from '../../utils/util'
import {
  queryByPage,
  savaClass,
  updateClass,
  deleteClass,
  queryClassDetail,
  generateQRCode
} from '../../api/classInfo'
import Pagination from '../../components/Pagination'
import axios from "axios";
import Template from "../../components/template";
import {selectAreaTree} from "../../api/subjectTree";
import {getMarketingChannelList} from "../../api/userMG";
export default {
  data() {
    // 正则表达式用于验证手机号码
    const checkPhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (value != '' && value != undefined) {
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      systemFlag: JSON.parse(localStorage.getItem('userdata')).systemFlag,
      color_index: 0,
      url: '/api/student/upload',
      fileList: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      // rules表单验证
      rules: {
        subjectId: [
          { required: true, message: '请输入培训科目', trigger: 'blur' }
        ],
        className: [
          { required: true, message: '请输入班级名称', trigger: 'blur' }
        ],
        bzrPhone: [
          { validator: checkPhone, trigger: 'blur' }
        ]
      },
      queryParams: {
        page: 1,
        size: 10
      },
      listData: [], //用户数据
      access_token: '', // 百度文字识别 token
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 左侧树
      treeArr: [],  // 默认展示第二级树节点
      treeOptions: undefined,


      marList: [],    // 营销渠道列表
      shareUrl: '',     // 二维码图片地址
   }
  },
  // 注册组件
  components: {
    Template,
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    timestampToTime,
    formatInportData,
    changeColor(name) {
      const newStr = name.replace(/“([^“”]*)”/g, '<span style="color: red;">$1</span>');
      return newStr;
    },
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    initData() {
      this.getdata()
      this.selectAreaTree()
    },

    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })
        }
      })
    },

    // 获取列表
    getdata() {
      // this.identificationRecognize();
      this.loading = true

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryByPage(this.queryParams).then(res => {
          this.loading = false
          if (res.code != 200) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.content
            // 分页赋值
            this.pageparm = res.data.pageparm
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },

    openStudent(item) {
      var {href} = this.$router.resolve({
        path: "/goods/student",
        query: {
          bjbId: item.id
        }
      })
      window.open(href, '_blank');
    },

    // 搜索事件
    search() {
      this.getdata()
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormShow = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        queryClassDetail(row).then(res => {
          if (res.code == 200) {
            this.form = res.data;
          }
        })
      } else {
        this.title = '添加'
        this.form = {}
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if (this.form.id) {
            updateClass(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '修改成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('修改失败，请稍后再试！')
            })

          } else {
            // 新增
            savaClass(this.form).then(res => {
              this.editFormShow = false
              this.loading = false
              if (res.code == 200) {
                this.getdata()
                this.form = {}
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    deleteUser(index, row) {
      this.$confirm('确定要删除该条数据吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteClass(row).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getdata()
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.response.data.msg)
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.form = {}
      this.editFormShow = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.tree-con {
  width: 250px;
  height: 95%;
  vertical-align: text-top;
  margin-top: 20px;
  display: inline-block;
  border: #544E4F 2px solid;
  border-radius: 8px;
}

</style>





// WEBPACK FOOTER //
// src/views/goods/classInfo.vue